// function to compare based on a numeric property
export function compareByNumericProp(prop, dir = 'asc') {
  const direction = dir === 'asc' ? 1 : -1;
  return (a, b) => {
    if (a[prop] < b[prop]) return -1 * direction;
    if (a[prop] > b[prop]) return 1 * direction;
    return 0;
  };
}

export function compareByProps(props, dir = 'asc') {
  const funcs = props.map((p) => compareByNumericProp(p, dir));
  return (a, b) => {
    for (let i = 0; i < funcs.length; i += 1) {
      const c = funcs[i](a, b);
      if (c !== 0) return c;
    }
    return 0;
  };
}

// Sort that breaks ties using the index of the array items
export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function arraysEqual(a, b) {
  return a.length === b.length && a.every((v, i) => objectsEqual(v, b[i]));
}

export function objectsEqual(a, b) {
  if (Object.is(a, b)) return true; // covers NaN, -0, same ref
  if (Array.isArray(a) && Array.isArray(b)) return arraysEqual(a, b);
  if (typeof a !== 'object' || typeof b !== 'object') return false;
  if (a === null || b === null) return false;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every((k) => Object.prototype.hasOwnProperty.call(b, k) && objectsEqual(a[k], b[k]));
}
